// Dependencies
import React, { Component } from 'react';
import image from '../assets/img/vector/contacto.svg';
import Section from '../layout/Section';
import SectionContainer from '../subcomponents/SectionContainer';
import TextImage from '../subcomponents/TextImage';
import FormularioContactoForm from '../subcomponents/FormularioContactoForm';

class Contacto extends Component {
  componentDidMount() {
    document.title = 'Contacto - Insacom';
  }
  render() {
    return (
      <Section no-contact>
        <SectionContainer grey backgroundColor="#f8ffff" paddingBottom={'0px'} paddingTop={100}>
          <TextImage
            image={image}
            title="Hablemos"
            description="Ponte en contacto con nosotros y uno de nuestros especialistas te apoyará con una asesoría en lo que necesitas."></TextImage>
        </SectionContainer>
        <section className="container g-pb-40 g-mt-60">
          <div className="row">
            <div className="col-md-8">
              <FormularioContactoForm asunto={'Formulario General'} />
            </div>
            <div className="col-lg-4 g-mb-60">
              <iframe
                title="Ubicación"
                style={{ width: '100%', border: 'none', height: 300 }}
                src="https://maps.google.cl/maps?f=q&amp;source=embed&amp;hl=es&amp;geocode=&amp;q=Err%C3%A1zuriz+1178+valparaiso&amp;aq=&amp;sll=-33.017881,-71.5627&amp;sspn=0.08334,0.154324&amp;ie=UTF8&amp;hq=&amp;hnear=Err%C3%A1zuriz+1178,+Valpara%C3%ADso&amp;t=m&amp;ll=-33.042253,-71.622965&amp;spn=0.058638,0.132093&amp;z=14&amp;output=embed"></iframe>
              <small></small>
              <hr className="g-my-40" />
              <h2 className="h3 mb-4">Información de Contacto</h2>
              <div className="media mb-2">
                <div className="media-body">
                  <div className="row">
                    <div className="col-lg-5 g-color-gray-dark-v3 mb-2">Dirección</div>
                    <div className="col-lg-7 g-color-gray-dark-v4">
                      Av. Errázuriz 1178 Piso 8, Of. 82, Valparaíso, Chile
                    </div>
                  </div>
                </div>
              </div>
              <div className="media mb-2">
                <div className="media-body">
                  <div className="row">
                    <div className="col-lg-5 g-color-gray-dark-v3 mb-2">Correo Comercial</div>
                    <div className="col-lg-7 g-color-gray-dark-v4">info@insacom.cl</div>
                  </div>
                </div>
              </div>
              <div className="media mb-2">
                <div className="media-body">
                  <div className="row">
                    <div className="col-lg-5 g-color-gray-dark-v3 mb-2">Correo Soporte</div>
                    <div className="col-lg-7 g-color-gray-dark-v4">soporte@insacom.cl</div>
                  </div>
                </div>
              </div>
              <div className="media mb-2">
                <div className="media-body">
                  <div className="row">
                    <div className="col-lg-5 g-color-gray-dark-v3 mb-2">Teléfono Central</div>
                    <div className="col-lg-7 g-color-gray-dark-v4">+56 32 2766718</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </Section>
    );
  }
}

export default Contacto;



// WEBPACK FOOTER //
// ./src/sections/Contacto.js